import styled from '@emotion/styled';
import { Div } from '../../../layouts';

export const FaresCalendarLegendEl = styled(Div)`
    &&& {
        margin-left: ${(props) => props.extraMarginLeft ? '70px' : '0'};
        margin-right: 0;
    }
`;
